export default "__VITE_ASSET__BHaxkiUj__"